import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		courseDates: null,
		tokenValue: null,
	},
	actions: {
		async loadCourseDates({ state, commit, rootState }, { eventType = 'sushi', accumulatorGroup = null } = {}) {
			const result = await service.loadCourseDates({ eventType, brand: config.BRAND, accumulatorGroup })

      // Polyfill
      result.forEach((l, i) => {
        if (typeof l.location !== 'object') {
          l.location = {
            name: l.location,
            brand: l.brand,
            code: l.code,
            region: l.region,
          }
          delete l.brand
          delete l.region
          delete l.code
        }

        if (Array.isArray(l.courses) && !Array.isArray(l.events)) {
          l.events = l.courses
          delete l.courses
        }

        l.events.forEach(course => {
          if (course.type == null && courseType != null) {
            course.type = courseType
          }
        })
      })

			commit('setCourseDates', { item: result })
		},
		async courseRegistration({ commit, dispatch }, { eventId, firstName, lastName, company, participants, street, streetNumber, city, postcode, email, phoneNumber, participantNames, notes, checkTerms, accumulatorGroup = null } = {}) {
			const result = await service.courseRegistration({ eventId, firstName, lastName, company, participants, street, streetNumber, city, postcode, email, phoneNumber, participantNames, notes, checkTerms, brand: config.BRAND, accumulatorGroup })
			commit('setTokenValue', { item: result.tokenValue })

			dispatch('redirect', {
				name: 'checkout-token',
				params: {
					basketToken: result.tokenValue
				}
			}, {root: true})
		}
	},
	getters: {
		courseDates (state) {
			return state.courseDates || []
		},
	},
	mutations: {
		setCourseDates: generateSetChild("courseDates"),
		setTokenValue: generateSetChild("tokenValue"),
	}
}
